<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="举办单位列表" name="1">
      <SponsorAdd :updataID='updataID'></SponsorAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 举办单位修改
 */
import SponsorAdd from '../../../../static/form/SponsorAdd.vue'
export default {
  components: {
    SponsorAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Kyzhgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/SponsorUpdate.vue